export function inRange(n, start, end, includeLeft, includeRight) {
  if (includeLeft === void 0) {
    includeLeft = true;
  }
  if (includeLeft && n === start || includeRight && n === end) return true;
  return n > start && n < end;
}